import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customNumber'
})
export class CustomNumberPipe implements PipeTransform {

  transform(value: number, decimalPoints: number = 2): string {
    if (value % 1 === 0) {
      return value?.toString();
    } else {
      return value?.toFixed(decimalPoints);
    }
  }
}